//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    ecuPackage: Object
  },
  computed: {
    brandImage () {
      try { return require(`~/assets/images/vehicle/makes/${this.ecuPackage.Make}.jpg`) } catch (e) { return null }
    },
    firmwareSourceImage () {
      try { return require(`~/assets/images/vehicle/firmware-sources/${this.ecuPackage.FirmwareSource}.jpg`) } catch (e) { return null }
    },
    classFromIntegration () {
      switch (this.ecuPackage.IntegrationType) {
        case 'Vehicle Custom ECU':
          return 'auto_integration_custom_vehicle'
        case 'Engine Custom ECU':
          return 'auto_integration_custom_engine'
        case 'Engine Tuning Base ECU':
          return 'auto_integration_tuning_base'
        case 'Engine GP ECU':
          return 'auto_integration_gp'
        case 'Contact For Details':
          return 'auto_integration_contact'
        default:
          // If we don't know, we'll call it a plug-in
          return 'auto_integration_plug_in'
      }
    }
  }
}
